/**
 * 本地存储
 * @param key
 * @param value
 */
function setStorage(key, value) {
    localStorage.setItem(key, value);
}

/**
 * 获取本地存储的值
 * @param key
 * @returns {string}
 */
function getStorage(key){
    return localStorage.getItem(key);
}

/**
 * 移除本地存储的值
 * @param key
 */
function removeStorage(key){
    localStorage.removeItem(key);
}
export {
    setStorage,
    getStorage,
    removeStorage
}